import React from "react";
import {
  closePopup,
  getNextDay,
  getTime,
  getToday,
  getValue,
  openPopup,
  reloadPopup,
  setValue
} from "../../../static/js/Common2";
import closeV2 from "../../../static/image/v2/popup/closeV2.png";
import closeBtn from "../../../static/image/v2/shop/closeBtn.png";
import openBtn from "../../../static/image/v2/shop/openBtn.png";
import plusBtn from "../../../static/image/v2/popup/plusBtn.png";
import minusBtn from "../../../static/image/v2/popup/minusBtn.png";
import {getShopInfoApi, shopOpenApi, shopStopApi} from "../../../static/js/service/shopService";

const ShopStopPopupV2 = React.memo(({shopList}) => {

  let openShop = shopList.filter((value) => value.statusTpcd === 6);
  let closeShop = shopList.filter((value) => value.statusTpcd === 5);

  if (openShop.length === 0) {
    openShop = shopList.filter((value) => value.status === 6);
  }
  if (closeShop.length === 0) {
    closeShop = shopList.filter((value) => value.status === 5);
  }


  // 오픈 중인 상점 리스트 생성
  const openShopList = openShop.map((value) => {
    return (
      <li className="selectoption" key={value.id} onClick={() => selectEvent("shopStopSelect", value.id, value.storeName)}>{value.storeName}</li>
    );
  });
  // 임시 정지 중인 상점 리스트 생성
  const closeShopList = closeShop.map((value) => {
    return (
      <li className="selectoption" key={value.id} onClick={() => selectEvent("shopOpenSelect", value.id, value.storeName)}>{value.storeName}</li>
    );
  });

  // 셀렉트 이벤트
  const selectEvent = (target, id, name) => {
    const targetElement = document.querySelector(`#${target} .selectText`);
    targetElement.setAttribute("data-id", id);
    targetElement.innerText = name;

    if(target === "shopOpenSelect" && id !== 0) {
      getShopInfoApi(id).then((response) => {
        const startTs = response.pauseStartDateTime.slice(2, 16);
        const endTs = response.pauseEndDateTime.slice(2, 16);
        document.querySelector(".shopOpenTime").classList.remove("hide");
        document.querySelector(".shopOpenTime .startDay1").innerText = startTs;
        document.querySelector(".shopOpenTime .endDay1").innerText = endTs;
      });
    } else {
      document.querySelector(".shopOpenTime").classList.add("hide");
    }
  }


  // 영업정지 팝업 출력 이벤트
  const stopPopupEvent = () => {
    const time = getTime().split(":");

    const hours1 = Number(time[0]);
    const minutes1 = Number(time[1]);
    let hours2 = Number(time[0])
    let minutes2 = Number(time[1]) + 10;

    if(minutes2 >= 60) {
      hours2 += 1;
      minutes2 -= 60;
    }
    if(hours2 >= 24) {
      hours2 -= 24;
    }

    setValue("startDay1", String(hours1).padStart(2, '0'));
    setValue("startDay2", String(minutes1).padStart(2, '0'));
    setValue("endDay1", String(hours2).padStart(2, '0'));
    setValue("endDay2", String(minutes2).padStart(2, '0'));
    document.querySelector("#shopStopSelect .selectTextBox").setAttribute("data-id", "0");
    document.querySelector("#shopStopSelect .selectTextBox").innerText = "미선택";

    openPopup("stopPopup");
  }

  // 시간 변경 이벤트
  const timeChangeEvent = (targetId, timeType, number) => {
    const targetValue = Number(getValue(targetId));

    if(timeType === 1) {
      // 시간일 경우
      if(targetValue + number > 23) {
        alert("0시~23시까지 설정할 수 있습니다.");
      } else {
        setValue(targetId, String(targetValue + number).padStart(2, '0'));
      }
    } else if(timeType === 2) {
      // 분일 경우
      if(targetValue + number > 59) {
        alert("0분~59분까지 설정할 수 있습니다.");
      } else {
        setValue(targetId, String(targetValue + number).padStart(2, '0'));
      }
    }
  }

  // 영업 임시 정지 이벤트
  const shopStopBtnEvent = () => {
    const shopId = Number(document.querySelector("#shopStopSelect .selectTextBox").getAttribute("data-id"));
    const shopName = document.querySelector("#shopStopSelect .selectTextBox").innerText;
    const today = getToday();
    const nextDay = getNextDay();
    const startTime = getValue("startDay1") + getValue("startDay2");
    const endTime = getValue("endDay1") + getValue("endDay2");

    if(shopId === 0) {
      alert("상점을 선택해주세요.");
      return false;
    }
    if(startTime.length !== 4) {
      alert("시작 시간을 입력해주세요.");
      return false;
    }
    if(startTime.length !== 4) {
      alert("종료 시간을 입력해주세요.");
      return false;
    }

    const startTs = `${today} ${getValue("startDay1")}:${getValue("startDay2")}:00`;
    let endTs = `${today} ${getValue("endDay1")}:${getValue("endDay2")}:59`;
    if(startTime - endTime > 0) {
      endTs = `${nextDay} ${getValue("endDay1")}:${getValue("endDay2")}:59`;
    }

    shopStopApi(shopId, startTs, endTs).then(() => {
      document.querySelector("#stopPopup2 .stop2Time span").innerText = `${getValue("startDay1")}:${getValue("startDay2")}~${getValue("endDay1")}:${getValue("endDay2")}`;
      document.querySelector("#stopPopup2 .stop2Name span").innerText = shopName;
      openPopup("stopPopup2");
    });
  }

  const shopOpenBtnEvent = () => {
    const shopTextBox = document.querySelector("#shopOpenSelect .selectTextBox");
    const shopId = Number(shopTextBox.getAttribute("data-id"));

    if(shopId === 0) {
      alert("상점을 선택해주세요.");
      return;
    }

    shopOpenApi(shopId).then(() => {
      const shopName = shopTextBox.innerText;
      const startTs = document.querySelector(".shopOpenTime .startDay1").innerText.slice(9, 14);
      const endTs = document.querySelector(".shopOpenTime .endDay1").innerText.slice(9, 14);

      document.querySelector("#openPopup2 .stop2Name span").innerText = shopName;
      document.querySelector("#openPopup2 .stop2Time span").innerText = `${startTs} ~ ${endTs}`;

      openPopup("openPopup2");
    });
  }

  return (
    <div>
      <div id="stopChoicePopup" className='stopChoicePopup popupV2 hide'>
        <div className='popupContainer width436'>
          <div className='popupTitle'>
            <button className='closeBtn stopCloseBtn' onClick={() => closePopup("stopChoicePopup")}>
              <img src={closeV2} alt='취소' />
            </button>
          </div>
          <div className='popupContent shopChoiceBox'>
            <button className='openBtn' onClick={stopPopupEvent}><img src={ closeBtn } alt="닫기" /></button>
            <button className='openBtn' onClick={() => openPopup("openPopup")}><img src={ openBtn } alt="열기" /></button>
          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn oneBtn' onClick={() => closePopup("stopChoicePopup")}>닫기</button>
          </div>
        </div>
      </div>

      <div id="stopPopup" className='stopPopup popupV2 hide'>
        <div className='popupContainer'>
          <div className='popupTitle'>
            <h2>영업일시중지 설정</h2>
            <button className='closeBtn stopCloseBtn' onClick={() => closePopup("stopPopup")}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <div className='popupContent'>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>상점</div>
              <div className='flexContent'>
                <div id='shopStopSelect' className='popupSelect select selectBox'>
                  <div className="selectText selectTextBox" data-href='shopStopSelect' data-id="0">미선택</div>
                  <ul id="shopStopSelectUl" className='selectOptionListBox selectOptionList' data-href='shopStopSelect'>
                    <li className="selectoption" onClick={() => selectEvent("shopStopSelect", 0, "미선택")}>미선택</li>
                    {openShopList}
                  </ul>
                </div>
              </div>
            </div>
            <div className='popupFlexBox'>
              <div className='flexTitle'>일시중지 시간</div>
              <div className='flexContent stopInputListBox'>
                <div className='stopInputList'>
                  <button className='plusBtn1 plusBtn' onClick={() => timeChangeEvent("startDay1", 1, 1)}><img src={ plusBtn } alt='플러스 버튼' /></button>
                  <input type='number' id='startDay1' />
                  <button className='minusBtn1 minusBtn' onClick={() => timeChangeEvent("startDay1", 1, -1)}><img src={ minusBtn } alt='마이너스 버튼' /></button>
                </div>
                <span>:</span>
                <div className='stopInputList'>
                  <button className='plusBtn2 plusBtn' onClick={() => timeChangeEvent("startDay2", 2, 1)}><img src={ plusBtn } alt='플러스 버튼' /></button>
                  <input type='number' id='startDay2' />
                  <button className='minusBtn2 minusBtn' onClick={() => timeChangeEvent("startDay2", 2, -1)}><img src={ minusBtn } alt='마이너스 버튼' /></button>
                </div>
                <span className='spanCenter'>~</span>
                <div className='stopInputList'>
                  <button className='plusBtn1 plusBtn' onClick={() => timeChangeEvent("endDay1", 1, 1)}><img src={ plusBtn } alt='플러스 버튼' /></button>
                  <input type='number' id='endDay1' />
                  <button className='minusBtn1 minusBtn' onClick={() => timeChangeEvent("endDay1", 1, -1)}><img src={ minusBtn } alt='마이너스 버튼' /></button>
                </div>
                <span>:</span>
                <div className='stopInputList'>
                  <button className='plusBtn2 plusBtn' onClick={() => timeChangeEvent("endDay2", 2, 1)}><img src={ plusBtn } alt='플러스 버튼' /></button>
                  <input type='number' id='endDay2' />
                  <button className='minusBtn2 minusBtn' onClick={() => timeChangeEvent("endDay2", 2, -1)}><img src={ minusBtn } alt='마이너스 버튼' /></button>
                </div>
              </div>
            </div>
          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn stopCloseBtn' onClick={() => closePopup("stopPopup")}>취소</button>
            <button type='button' className='stopBtn blueBtn' onClick={shopStopBtnEvent}>확인</button>
          </div>
        </div>
      </div>

      <div id="stopPopup2" className='stopPopup2 popupV2 hide'>
        <div className='popupContainer width436'>
          <div className='popupTitle'>
            <button className='closeBtn stop2CloseBtn' onClick={reloadPopup}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <div className='popupContent'>
            <p className='stop2Time'>영업일시중지(<span></span>)가<br />설정되었습니다.</p>
            <p className='stop2Name'>(상점 : <span></span>)</p>
          </div>
          <div className='popupBtn'>
            <button type='button' className='blueBtn oneBtn' onClick={reloadPopup}>확인</button>
          </div>
        </div>
      </div>

      <div id="openPopup" className='openPopup popupV2 hide'>
        <div className='popupContainer'>
          <div className='popupTitle'>
            <h2>영업일시중지 해제</h2>
            <button className='closeBtn' onClick={() => closePopup("openPopup")}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <div className='popupContent'>
            <div className='popupContentTitle'>일시중지 중인 상점</div>
            <div className='flexContent'>
              <div id='shopOpenSelect' className='popupSelect select selectBox'>
                <div className='selectText selectTextBox' data-href='shopOpenSelect' data-id="0">미선택</div>
                <ul id="shopOpenSelectUl" className='selectOptionListBox selectOptionList' data-href='shopOpenSelect'>
                  <li className='selectoption' onClick={() => selectEvent("shopOpenSelect", 0, "미선택")}>미선택</li>
                  {closeShopList}
                </ul>
              </div>
              <p className='shopOpenTime hide'>
                <span className='startDay1'></span>&nbsp;~&nbsp;
                <span className='endDay1'></span>&nbsp;
                <span className='red'>일시중지 설정 중</span>
              </p>
            </div>
          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn' onClick={() => closePopup("openPopup")}>취소</button>
            <button type='button' className='shopOpenBtn blueBtn' onClick={shopOpenBtnEvent}>확인</button>
          </div>
        </div>
      </div>

      <div id="openPopup2" className='openPopup2 popupV2 hide'>
        <div className='popupContainer width436'>
          <div className='popupTitle'>
            <button className='closeBtn' onClick={reloadPopup}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <div className='popupContent'>
            <p className='stop2Time'>영업일시중지(<span></span>)가<br />해제되었습니다.</p>
            <p className='stop2Name'>(상점 : <span></span>)</p>
          </div>
          <div className='popupBtn'>
            <button type='button' className='blueBtn oneBtn' onClick={reloadPopup}>확인</button>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ShopStopPopupV2;